import { z } from 'zod';

export enum ListingActivityChangeKind {
  ADDED = 'added',
  REMOVED = 'removed',
  CHANGED = 'changed',
  UPDATED = 'updated',
}

export enum ListingActivityPricingKind {
  TIER = 'tier',
  SETTINGS = 'settings',
  LIST = 'list',
  ITEM = 'item',
}

export const ListingActivityPriceItemSchema = z.object({
  name: z.string(),
  price: z.string(),
  maxQuantity: z.number().optional(),
});

export const ListingActivityDisplaySchema = z.object({
  label: z.string(),
  imageUrl: z.string().optional(),
  originalUrl: z.string().optional(),
  priceItems: z.array(ListingActivityPriceItemSchema).optional(),
});

export const ListingActivityPricingSchema = z.object({
  kind: z.nativeEnum(ListingActivityPricingKind),
  tierLabel: z.string(),
  beforeName: z.string().optional(),
  afterName: z.string().optional(),
  beforeItem: ListingActivityPriceItemSchema.optional(),
  afterItem: ListingActivityPriceItemSchema.optional(),
});

export const ListingActivityPhotoMoveSchema = z.object({
  from: z.number(),
  to: z.number(),
  label: z.string(),
  imageUrl: z.string().optional(),
  originalUrl: z.string().optional(),
});

export const ListingActivityChangeSchema = z.object({
  path: z.string(),
  label: z.string().optional(),
  summary: z.string().optional(),
  context: z.string().optional(),
  summaryOnly: z.boolean().optional(),
  kind: z.nativeEnum(ListingActivityChangeKind).optional(),
  before: z.unknown().optional(),
  after: z.unknown().optional(),
  beforeDisplay: ListingActivityDisplaySchema.optional(),
  afterDisplay: ListingActivityDisplaySchema.optional(),
  pricing: ListingActivityPricingSchema.optional(),
  photoDisplay: ListingActivityDisplaySchema.optional(),
  photoItems: z.array(ListingActivityDisplaySchema).optional(),
  photoMoves: z.array(ListingActivityPhotoMoveSchema).optional(),
});
